// extracted by mini-css-extract-plugin
module.exports = {"noDataContainer":"noData_noDataContainer__2VSHn","lottieContainer":"noData_lottieContainer__2VU2F"};